import { useEffect, useState } from "react"; // Restoring useEffect, as it was likely part of the react-simply-carousel setup
import ReactSimplyCarousel from 'react-simply-carousel';
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"; // Import icons
import Avatar from "./Avatars";

const AvatarsCarousel = ({ people, handleSelect, currentChat }) => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

    useEffect(() => {
    // console.log('AvatarsCarousel people:', people.map(p => p.channel_id));
    // console.log('AvatarsCarousel people length:', people?.length);
  }, [people]);

  const numPeople = people?.length || 0;
  const maxItemsVisible = 4; // Configure how many avatars to show at most
  // Determine how many items to show: either the number of people, or maxItemsVisible, whichever is smaller.
  // Ensure at least 1 if people exist, to prevent division by zero if numPeople is 0 but carousel renders.
  const itemsToShow = numPeople > 0 ? Math.min(numPeople, maxItemsVisible) : 1;

  return (
    <div className="bg-white p-3 rounded-xl shadow-sm overflow-hidden"> {/* Outer container for the carousel */}
      {numPeople > 0 ? (
        <ReactSimplyCarousel
          activeSlideIndex={activeSlideIndex}
          onRequestChange={setActiveSlideIndex}
          itemsToShow={itemsToShow}
          itemsToScroll={1}
          forwardBtnProps={{
            className: "p-1.5 mx-1 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-1 focus:ring-sky-400 transition-colors",
            children: <ChevronRightIcon className="h-4 w-4" />,
          }}
          backwardBtnProps={{
            className: "p-1.5 mx-1 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-1 focus:ring-sky-400 transition-colors",
            children: <ChevronLeftIcon className="h-4 w-4" />,
          }}
          responsive={false} // Using dynamic itemsToShow based on numPeople instead of predefined breakpoints
          speed={400}
          easing="linear"
          containerProps={{
            style: { width: '100%' }, // Ensure carousel takes full width
            // Use flex to lay out buttons and item track in a row, centered vertically.
            className: "flex items-center"
          }}
          // The innerProps are for the div that directly wraps the items.
          // Make this part flexible to take available space between buttons.
          innerProps={{
            // flex-1 allows it to grow/shrink. overflow-hidden is good for tracks.
            className: "flex-1 overflow-hidden"
          }}
          // Optional: you can uncomment the line below to hide navigation buttons if all items are visible
          // showNavIfAllVisible={false}
        >
          {people.map((user) => ( 
            <div key={user.channel_id} style={{ width: `${100 / itemsToShow}%`, padding: '0 4px' }} onClick={() => handleSelect(user)}>
              <Avatar user={user} currentChat={currentChat} />
            </div>
          ))}
        </ReactSimplyCarousel>
      ) : (
        <div className="text-center text-gray-500 py-4">No users to display</div> // Fallback for empty list
      )}
    </div>
  );
};

export default AvatarsCarousel;
